import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=55de7926"
import script from "./Confirmation.vue?vue&type=script&lang=ts"
export * from "./Confirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports